import * as React from 'react'
import LargeNumber from '../../../helper/large-number'

interface Props {
    message?: {
        args: {
            ct: number
        }
    }
}

export default class ErrorHandlerBottleneck extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let info = (
            <p>
                The excessive use of the <code>Symfony\Component\ErrorHandler\ErrorHandler::handleError</code> function can lead to
                performance issues.
            </p>
        )

        if (message) {
            info = (
                <p>
                    The <code>Symfony\Component\ErrorHandler\ErrorHandler::handleError</code> function was called{' '}
                    <LargeNumber value={message.args.ct} class="" /> times in this trace.
                </p>
            )
        }

        return (
            <div>
                {info}
                <p>
                    This happens because the code is triggering PHP warnings, notices or deprecations and handles them through Symfony.
                    Triggering the error handler stack is a wasteful operation and usually it is possible to rewrite the code not to trigger
                    these warnings, but in some cases it is not possible.
                </p>
            </div>
        )
    }
}
